import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";

type HandlerType = Handler<GetBillTosApiParameter>;

export const DispatchUpdateBillTosSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Pages/RfqMyQuotes/UpdateBillTosSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateBillTosSearchFields];

const updateBillTosSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateBillTosSearchFields");
export default updateBillTosSearchFields;
